module.exports = __webpack_public_path__ + "static/media/C-32-wh.5689d3ba.png";